// src/utils/translations.js

export const translations = {
  TR: {
    navbar: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      products: "Ürünlerimiz",
      tech: "Teknik Föyler",
      blog: "Blog",
      contact: "İletişim"
    },
    hero: {
      badge: "Since 2006 • Yaklaşık 20 Yıllık Tecrübe",
      title: "Hayvan Besleme ve Yem",
      highlight: "Katkılarında Güçlü Çözümler",
      desc: "Premiksler, akıllı yemler, buzağı ürünleri, bypass yağlar, sağım hijyeni, elektrolitler ve özel formülasyonlarla hayvancılığa değer katıyoruz.",
      btnPrimary: "Ürünleri İncele",
      btnSecondary: "Kataloğu Gör"
    },
    catalog: {
      hero: {
        badge: "Since 2006 • İhracat ve İhale Portföyü",
        title1: "Hayvan Besleme ve",
        title2: "Yem Katkılarında",
        highlight: "Dijital Katalog Sistemi",
        desc: "Bigma Grup ürünleri; teknik analizler ve kullanım kılavuzlarıyla dijital ortamda sunulur.",
        btnGroups: "Ürün Gruplarını İncele",
        btnSystem: "Katalog Sistemini Aç",
        btnPortfolio: "İhracat / İhale Portföyü"
      },
      categories: {
        badge: "Bigma Katalogları",
        title: "Ürün Gruplarımız",
        subtitle: "Sektöre özel hazırladığımız rasyon ve premix gruplarını inceleyin.",
        unit: "Çeşit Ürün",
        btn: "Ürünleri İncele"
      },
      productCard: {
        animal: "Hayvan grubu:",
        pkg: "Ambalaj:",
        license: "Ruhsat/Not:",
        barcode: "Barkod:",
        techTable: "Teknik Analiz",
        guide: "Kullanım Kılavuzu",
        btn: "Ürün Katalog Sayfası",
        analysis1: "Ham Protein",
        analysis2: "Ham Yağ",
        analysis3: "Ham Kül",
        analysis4: "Ham Selüloz",
        analysis5: "Nem"
      },
      productShowcase: {
        returnBtn: "Tüm Ürünlere Dön",
        techInfo: "Teknik Bilgi",
        infoTitle: "Ürün Bilgisi",
        analysisTitle: "Teknik Analiz",
        guideTitle: "Kullanım Kılavuzu",
        tableComp: "Bileşen",
        tableVal: "1 kg üründe değer",
        warning: "Bu bir ilaç değildir. Yem katkısıdır / besleme destek ürünüdür. Tedavi amacıyla kullanılmaz.",
        footerName: "BIGMA GRUP BIOTECHNOLOGIES A.Ş.",
        footerAddr: "Organize Sanayi Bölgesi 3. Kısım 6. Cad. No:49 Sivas"
      },
      export: {
        badge: "İhracat ve İhale Portföyü",
        mainTitle: "Türkiye, Afrika, Balkanlar, Cezayir, Orta Doğu ve Arap Pazarı",
        subtitle: "Veteriner hekimler, resmi kurumlar ve profesyonel işletmeler için global standartlarda teknik portföy sunuyoruz.",
        card1: "Resmi Kurumlar ve İhaleler",
        card1Desc: "Teknik föy, analiz, ruhsat numarası ve ürün dosyasıyla sunulabilir yapı.",
        card2: "Veteriner Hekimler",
        card2Desc: "Hayvan türüne ve saha ihtiyacına göre ayrılmış teknik destek ürünleri.",
        card3: "Afrika ve Balkanlar",
        card3Desc: "İhracat pazarları için çok dilli ürün tanıtımı ve geniş portföy sunumu.",
        card4: "Arap Pazarı ve Deve Ürünleri",
        card4Desc: "Deve premiksi, elektrolit ve kondisyon destek ürünleriyle ayrı pazar dili."
      }
    },
    aboutSection: {
      badge: "Hakkımızda",
      title: "2006’dan Bu Yana Hayvancılığın Yanındayız",
      p1: "Bigma Grup Biotechnologies A.Ş., 2006 yılında kurulmuş; hayvan besleme, yem katkıları, premiksler ve sağım hijyeni alanında faaliyet gösteren kurumsal üretici firmadır.",
      p2: "Bilimsel yaklaşımımız ve üretim gücümüzle çiftliklerin verimlilik hedeflerine katkı sağlıyoruz."
    }
  },
  EN: {
    navbar: {
      home: "Home",
      about: "About Us",
      products: "Products",
      tech: "Technical Sheets",
      blog: "Blog",
      contact: "Contact"
    },
    hero: {
      badge: "Since 2006 • Nearly 20 Years of Experience",
      title: "Strong Solutions in",
      highlight: "Animal Nutrition and Additives",
      desc: "We add value to livestock with premixes, smart feeds, bypass fats, and special formulations.",
      btnPrimary: "View Products",
      btnSecondary: "View Catalog"
    },
    catalog: {
      hero: {
        badge: "Since 2006 • Export and Tender Portfolio",
        title1: "Digital Catalog System",
        title2: "for Animal Nutrition",
        highlight: "and Feed Additives",
        desc: "Bigma Group products are presented digitally with technical analysis and usage guides.",
        btnGroups: "Examine Product Groups",
        btnSystem: "Open Catalog System",
        btnPortfolio: "Export / Tender Portfolio"
      },
      categories: {
        badge: "Bigma Catalogs",
        title: "Our Product Groups",
        subtitle: "Examine our specially prepared ration and premix groups.",
        unit: "Product Types",
        btn: "Examine Products"
      },
      productCard: {
        animal: "Animal group:",
        pkg: "Packaging:",
        license: "License/Note:",
        barcode: "Barcode:",
        techTable: "Technical Analysis",
        guide: "Usage Guide",
        btn: "Product Catalog Page",
        analysis1: "Crude Protein",
        analysis2: "Crude Fat",
        analysis3: "Crude Ash",
        analysis4: "Crude Cellulose",
        analysis5: "Moisture"
      },
      productShowcase: {
        returnBtn: "Back to All Products",
        techInfo: "Technical Info",
        infoTitle: "Product Information",
        analysisTitle: "Technical Analysis",
        guideTitle: "Usage Guide",
        tableComp: "Component",
        tableVal: "Value in 1 kg",
        warning: "This is not a medicine. It is a feed additive / nutritional support product. Not for therapeutic use.",
        footerName: "BIGMA GROUP BIOTECHNOLOGIES INC.",
        footerAddr: "Organized Industrial Zone 3rd Section 6th St. No:49 Sivas"
      },
      export: {
        badge: "Export and Tender Portfolio",
        mainTitle: "Turkey, Africa, Balkans, Algeria, Middle East and Arab Market",
        subtitle: "We offer a global technical portfolio for veterinarians, official institutions, and professional enterprises.",
        card1: "Official Institutions and Tenders",
        card1Desc: "Documentable with technical sheets, analysis, and registration files.",
        card2: "Veterinarians",
        card2Desc: "Technical support products categorized by species and field needs.",
        card3: "Africa and Balkans",
        card3Desc: "Multilingual promotion and wide portfolio for export markets.",
        card4: "Arab Market and Camel Products",
        card4Desc: "Special portfolio with camel premix, electrolyte, and support products."
      }
    }
  },
  AR: {
    navbar: {
      home: "الصفحة الرئيسية",
      about: "عن الشركة",
      products: "منتجاتنا",
      tech: "البيانات الفنية",
      blog: "المدونة",
      contact: "اتصل بنا"
    },
    catalog: {
      hero: {
        badge: "منذ عام 2006 • محفظة التصدير والمناقصات",
        title1: "نظام الكتالوج الرقمي",
        title2: "لتغذية الحيوان",
        highlight: "وإضافات الأعلاف",
        desc: "يتم تقديم منتجات مجموعة بيجما رقمياً مع التحليلات الفنية وأدلة الاستخدام.",
        btnGroups: "فحص مجموعات المنتجات",
        btnSystem: "افتح نظام الكتالوج",
        btnPortfolio: "محفظة التصدير / المناقصات"
      },
      categories: {
        badge: "كتالوجات بيجما",
        title: "مجموعات منتجاتنا",
        subtitle: "افحص مجموعات الحصص والمخاليط الجاهزة المحضرة خصيصاً لقطاعك.",
        unit: "نوع المنتج",
        btn: "فحص المنتجات"
      },
      productCard: {
        animal: "فصيلة الحيوان:",
        pkg: "التعبئة:",
        license: "الترخيص:",
        barcode: "الباركود:",
        techTable: "التحليل الفني",
        guide: "دليل الاستخدام",
        btn: "صفحة كتالوج المنتج",
        analysis1: "بروتين خام",
        analysis2: "دهون خام",
        analysis3: "رماد خام",
        analysis4: "ألياف خام",
        analysis5: "رطوبة"
      },
      productShowcase: {
        returnBtn: "العودة إلى جميع المنتجات",
        techInfo: "معلومات فنية",
        infoTitle: "معلومات المنتج",
        analysisTitle: "التحليل الفني",
        guideTitle: "دليل الاستخدام",
        tableComp: "المكونات",
        tableVal: "القيمة في 1 كجم",
        warning: "هذا ليس دواءً. إنه مضاف علفي. لا يستخدم للأغراض العلاجية.",
        footerName: "بيجما جروب للتكنولوجيا الحيوية ش.م.",
        footerAddr: "المنطقة الصناعية المنظمة القسم الثالث الشارع السادس رقم 49 سيواس"
      },
      export: {
        badge: "محفظة التصدير والمناقصات",
        mainTitle: "تركيا، أفريقيا، البلقان، الجزائر، الشرق الأوسط والسوق العربي",
        subtitle: "نحن نقدم محفظة فنية عالمية للأطباء البيطريين والمؤسسات الرسمية.",
        card1: "المؤسسات الرسمية والمناقصات",
        card1Desc: "جاهز للتقديم مع ورقة البيانات الفنية وملف التسجيل.",
        card2: "الأطباء البيطريين",
        card2Desc: "منتجات الدعم الفني مقسمة حسب احتياجات الميدان.",
        card3: "أفريقيا والبلقان",
        card3Desc: "ترويج المنتجات بلغات متعددة لأسواق التصدير.",
        card4: "السوق العربي ومنتجات الإبل",
        card4Desc: "لغة سوق منفصلة مع بريمكس الإبل ومنتجات الدعم."
      }
      ,
      // translations.js içine eklenecekler:
TR: { catalog: { productGrid: { noProducts: "Bu kategoriye ait ürün bulunamadı." } } },
EN: { catalog: { productGrid: { noProducts: "No products found in this category." } } },
AR: { catalog: { productGrid: { noProducts: "لم يتم العثور على منتجات في هذه الفئة." } } }
    }
  }
};